export default __webpack_public_path__ + "static/media/productmgr-hover.fa92a3e0.svg";